import { Outlet } from 'react-router-dom'
import Sidebar from '../../components/sidebar/Sidebar'
// import SessionCountdown from './countdown/SessionCountdown'
import { SessionPg } from './styled'

const Sessions = () => {
  return (
    <SessionPg>
      {/* <SessionCountdown /> */}
      <div className="content-container">
        <Sidebar />
        <Outlet />
      </div>
    </SessionPg>
  )
}

export default Sessions
